module.exports = __webpack_public_path__ + "static/media/SAJEK.c530f679.png";